export default function HomeClosingCTA() {
  return (
    <section className="av-closing" aria-labelledby="av-closing-title">
      <div className="av-shell">
        <p className="av-label">Contact Averentia</p>
        <h2 id="av-closing-title">Discuss your transformation priorities.</h2>
        <a
          className="av-button av-button-light"
          href="https://calendly.com/ritwik-averentia"
          target="_blank"
          rel="noreferrer"
        >
          Talk to our team <span aria-hidden="true">↗</span>
        </a>
      </div>
    </section>
  );
}
